import { scaleDown as Menu } from 'react-burger-menu';
import styled from 'styled-components';
import { darkTheme } from '../theme/theme';

const sidebarStyles = (theme) => ({
  bmBurgerButton: {
    position: 'fixed',
    width: '36px',
    height: '30px',
    left: '36px',
    top: '36px'
  },
  bmBurgerBars: {
    background: theme.colors.buttonBgColor
  },
  bmBurgerBarsHover: {
    background: theme.colors.buttonHoverBg
  },
  bmCrossButton: {
    height: '24px',
    width: '24px'
  },
  bmCross: {
    background: theme.colors.text
  },
  bmMenuWrap: {
    position: 'fixed',
    height: '100%'
  },
  bmMenu: {
    background: theme.colors.navBgColor,
    padding: '2.5em 1.5em 0',
    fontSize: '1.15em'
  },
  bmMorphShape: {
    fill: theme.colors.navBgColor
  },
  bmItemList: {
    color: theme.colors.text,
    padding: '0.8em'
  },
  bmItem: {
    display: 'block',
    color: theme.colors.text,
    marginBottom: '10px',
    textAlign: 'left',
    textDecoration: 'none',
    transition: 'color 0.2s'
  },
  bmOverlay: {
    background: 'rgba(0, 0, 0, 0.3)'
  }
});

const MenuItem = styled.a`
  display: block;
  color: ${props => props.theme.colors.text};
  margin-bottom: 10px;
  text-align: left;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: ${props => props.theme.colors.buttonBgColor};
  }
`;

const Sidebar = props => {
  return (
    <Menu 
      pageWrapId={props.pageWrapId}
      outerContainerId={props.outerContainerId}
      styles={sidebarStyles(darkTheme)}
    >
      <MenuItem id="home" href="/">
        Home
      </MenuItem>
      <MenuItem id="weekly-picks" href="/weekly-picks">
        Weekly Picks
      </MenuItem>
    </Menu>
  )
}

export default Sidebar;